// Prevent dragging images to desktop
document.querySelectorAll('img').forEach((img) => {
    img.addEventListener('dragstart', (e) => {
        e.preventDefault();
    });
});

// Prevent Print Screen or screenshot 
document.addEventListener('keydown', (e) => {
    if (e.key === 'PrintScreen') {
        e.preventDefault();
    }
});

// Prevent right-click image download
document.querySelectorAll('img').forEach((img) => {
    img.addEventListener('contextmenu', (e) => {
        e.preventDefault();
    });
});